import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/substitution-actions';
import { SubstitutionActions } from '../constants';
import { ISubstitution } from 'src/types/substitution';

export interface SubstitutionState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<ISubstitution>;
    current: ISubstitution | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    current: null,
    currentFiles: null,
};

export function substitutions(state: SubstitutionState = initialState, action: Actions | any): SubstitutionState {
    switch (action.type) {
        case requestType(SubstitutionActions.FETCH_SUBSTITUTIONS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(SubstitutionActions.FETCH_SUBSTITUTIONS):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(SubstitutionActions.FETCH_SUBSTITUTIONS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(SubstitutionActions.FETCH_SUBSTITUTION):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(SubstitutionActions.FETCH_SUBSTITUTION):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(SubstitutionActions.FETCH_SUBSTITUTION):
            return { ...state, inProgress: false, error: action.error };

        case successType(SubstitutionActions.DELETE_SUBSTITUTION):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: ISubstitution) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(SubstitutionActions.DELETE_SUBSTITUTION):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        case requestType(SubstitutionActions.FETCH_FILES_SUBSTITUTION):
            return { ...state, error: '', inProgress: true };
        case successType(SubstitutionActions.FETCH_FILES_SUBSTITUTION):
            return { ...state, inProgress: false, currentFiles: action.payload };
        case failureType(SubstitutionActions.FETCH_FILES_SUBSTITUTION):
            return { ...state, inProgress: false, error: action.error };

        case successType(SubstitutionActions.DELETE_FILE_SUBSTITUTION):
            const { sagaPayload } = action;
            const curNewFiles = (state.currentFiles ?? []).filter((file: any) => file.id !== sagaPayload.id);

            return {
                ...state,
                inProgress: false,
                currentFiles: curNewFiles,
            };
        case failureType(SubstitutionActions.DELETE_FILE_SUBSTITUTION):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case successType(SubstitutionActions.CREATE_FILES_SUBSTITUTION):
            const curFiles = [...(state.currentFiles ?? [])];
            curFiles.push(action.payload);

            return {
                ...state,
                inProgress: false,
                currentFiles: curFiles,
            };
        case failureType(SubstitutionActions.CREATE_FILES_SUBSTITUTION):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        default:
            return state;
    }
}
